import _ from 'lodash'
import { useEffect, useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import InfoPopup from '../../../../common/components/InfoPopup';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { getBodyType } from '../../../../common/services/common.service';

export default function VehicleCard({ loadCapacity, isButtonLoading, vehicleData, productTypeCargo, handleEstimate, selectedEstimateItem, handleInnerFormChange }: any) {

    const [vehicle, setVehicle] = useState<any>();
    const [selectVehicleData, setSelectVehicleData] = useState<any>([]);
    const [infoOpen, setInfoOpen]: any = useState(false)

    const dummyImage = require('../../../../assets/img/image.png')
    const onEstimateClick = () => {
        handleEstimate(vehicle)
    }
    useEffect(() => {
        const input = document.getElementById("datetime") as HTMLInputElement;

        input.addEventListener("change", function () {
            const minDateTime = new Date(input.min);
            const selectedDateTime = new Date(input.value);
            if (selectedDateTime < minDateTime) {
                alert("Please select a valid time.");
                input.value = input.min; // reset to min
            }
        });

    }, []);

    useEffect(() => {

        if (selectedEstimateItem?.vehicleCategoryId) {
            const CapacityData: any = _.filter(vehicleData, ['LogisticsVehicleCategoryId', Number(selectedEstimateItem?.vehicleCategoryId)]);
            setSelectVehicleData(CapacityData)
        }
    }, [selectedEstimateItem]);

    useEffect(() => {
        if (!selectedEstimateItem?.CategoryId && loadCapacity?.length > 0) {
            handleInnerFormChange(loadCapacity[0].Id, 'vehicleCategoryId');
        }
    }, [loadCapacity]);

    return (
        <>
            <InfoPopup data={vehicle} open={infoOpen} setOpen={setInfoOpen} />
            <div className="max-w-3xl mx-auto mt-10  p-6 rounded-2xl shadow-lg bg-white">
                <h2 className="text-xl font-semibold mb-4">Estimate Vehicle Category Type</h2>
                <div className="mb-6">
                    <div className="pb-5 w-full">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Vehicle Loading Capacity:
                        </label>
                        <div className="flex flex-wrap gap-3">
                            {loadCapacity?.map((item, index) => {
                                const isActive = selectedEstimateItem?.vehicleCategoryId === item.Id;
                                return (
                                    <button
                                        key={index}
                                        type="button"
                                        onClick={() => handleInnerFormChange(item.Id, 'vehicleCategoryId')}
                                        aria-pressed={isActive}
                                        className={`text-sm px-3 py-1 border-b-2 transition-colors duration-200
                                       ${isActive ? 'border-blue-600 text-blue-700 font-semibold'
                                                : 'border-transparent text-gray-700 hover:border-blue-300 hover:text-blue-500'
                                            }`}
                                    >
                                        {item.LogisticsVehicleCategoryName}
                                    </button>
                                );
                            })}
                        </div>
                    </div>


                    {selectVehicleData && selectedEstimateItem?.vehicleCategoryId ?
                        <div className="grid grid-cols-5 gap-6">
                            {selectVehicleData?.map((item: any, index: any) => (
                                <button
                                    key={index}
                                    onClick={() => setVehicle(item)}
                                    className={
                                        vehicle == item
                                            ? "w-full relative flex flex-col justify-center items-center p-1 px-3 outline text-blue-500 outline-blue-500 rounded-md"
                                            : "w-full relative flex flex-col justify-center items-center p-1 px-3 outline outline-gray-200 rounded-md"
                                    }
                                >
                                    {/* Info Icon  */}
                                    <div onClick={() => setInfoOpen(!infoOpen)} title='info' className="absolute top-2 right-2 text-gray-400 hover:text-blue-500">
                                        <IoInformationCircleOutline className="w-4 h-4 text-gray-500 hover:text-gray-800" />
                                    </div>
                                    <div className="flex items-center justify-center w-full my-3 rounded-md">
                                        {item?.MediaMappings?.MediaFiles?.length > 0 ? (
                                            <img
                                                src={item.MediaMappings.MediaFiles[0].FileMappingURL}
                                                alt={item.LogisticsVehicleCategoryName}
                                                className="w-20 h-20 object-contain  "
                                            />
                                        ) : (
                                            <img
                                                src={dummyImage}
                                                alt={''}
                                                className="w-20 h-20 object-contain "
                                            />
                                        )}
                                    </div>
                                    <div>{`${item?.VehicleName}`}</div>
                                    <div>{getBodyType(item?.VehicleBodyTypeId)}</div>
                                </button>
                            ))}
                        </div> : <div className="text-sm text-gray-700 mr-2">
                            {selectVehicleData && selectedEstimateItem?.CategoryId ? "Vehicle not avilable for this category" : "Please select the Category "}
                        </div>}
                </div>
                <div className=" border-t w-full"></div>
                <div className="pt-4 grid grid-cols-2 gap-2 max-w-96">

                    <div className="text-sm text-gray-700 mr-2">
                        Selected:
                    </div>
                    <div className="text-sm text-gray-700 ">
                        <strong>{vehicle?.VehicleName || 'None'}</strong>
                    </div>
                    <div className="text-sm text-gray-700 mr-2">
                        Trip Base Price:
                    </div>
                    <div className="text-sm text-gray-700 ">
                        <strong>₹ {vehicle?.TripVehicleBasePrice || '0'}</strong>
                    </div>
                    {/* <div className="text-sm text-gray-700 mr-2">
                        Capacity:
                    </div>
                    <div className="text-sm text-gray-700 ">
                        <select
                            required
                            className="border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500  min-w-48 p-1"

                            onChange={(event) => handleInnerFormChange(event.target.value, 'SubCategoryId')}
                            value={selectedEstimateItem?.SubCategoryId || ""}

                        >
                            <option value={''} key={''}>
                                --select--
                            </option>
                            {loadCapacity?.map((item, index) => (
                                <option value={item.Id} key={index} >
                                    {item.displayLoadCapacity}
                                </option>
                            ))}
                        </select>
                    </div> */}
                    {/* <div className="text-sm text-gray-700 mr-2">
                        Vehicle Type:
                    </div>
                    <div className="text-sm text-gray-700 ">
                        <strong>{vehicle?.VehicleCategoryType || 'None'}</strong> ({vehicle?.VehicleCategoryBodyType})
                    </div> */}
                    <div className="text-sm text-gray-700 mr-2">
                        Loading Capacity:
                    </div>
                    <div className="text-sm text-gray-700 ">
                        <strong>{`${vehicle?.LoadingCapacity} Kg`}</strong>
                    </div>
                    <div className="text-sm text-gray-700 mr-2">
                        Vehicle Dimension(LxWxH):
                    </div>
                    <div className="text-sm text-gray-700 ">
                        <strong>{vehicle?.VehicleDimension?.length?.value || 0}x{vehicle?.VehicleDimension?.breadth?.value || 0}x{vehicle?.VehicleDimension?.height?.value || 0}  meter</strong>
                    </div>

                    <div className="text-sm text-gray-700 mr-2">
                        Product Type:
                    </div>
                    <div className="text-sm text-gray-700 ">
                        <select
                            required
                            className="border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500  min-w-48 p-1"

                            onChange={(event) => handleInnerFormChange(event.target.value, 'CategoryId')}
                            value={selectedEstimateItem?.CategoryId || ""}

                        >
                            <option value={''} key={''}>
                                --select--
                            </option>
                            {productTypeCargo?.map((item, index) => (
                                <option value={item.Id} key={index}>
                                    {item.Name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="text-sm text-gray-700 mr-2">
                        Approx. Product Price:
                    </div>
                    <div className="text-sm text-gray-700 ">
                        <div className="relative">
                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">₹</span>
                            <input
                                type="number"
                                onChange={(event) => handleInnerFormChange(event.target.value, 'ProductValue')}
                                value={selectedEstimateItem?.ProductValue}
                                placeholder="Enter amount"
                                className="pl-7 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                    </div>
                    <div className="text-sm text-gray-700 mr-2">
                        Schedule Date & Time:
                    </div>
                    <div className="text-sm text-gray-700">
                        <input
                            required
                            id="datetime"
                            type="datetime-local"
                            name="scheduleDate"
                            min={new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                                .toISOString()
                                .slice(0, 16)}
                            className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            onClick={(event) => {
                                const input = event.target as HTMLInputElement;
                                input.showPicker();
                            }}
                            onChange={(event) => handleInnerFormChange(event.target.value, 'date')}
                            value={selectedEstimateItem?.date}
                        />
                    </div>
                    <div></div>
                    <div>
                        <button
                            onClick={onEstimateClick}
                            disabled={isButtonLoading} className={`${isButtonLoading ? 'bg-blue-500 bg-opacity-70 w-24 ' : 'bg-blue-500 '}  text-white items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
                            Estimate
                            {isButtonLoading && <div className={`${isButtonLoading ? 'visible pl-1' : 'invisible'}`}>
                                <RotatingLines
                                    visible={true}
                                    width={'15'}
                                    strokeColor="#fff"
                                    strokeWidth="6"
                                    animationDuration="0.75"
                                    ariaLabel="rotating-lines-loading"
                                />
                            </div>}
                        </button>

                    </div>
                </div>

            </div>

        </>

    );
}
